import { ThemeProvider as Provider } from 'styled-components'

import { theme } from './theme'

export const ThemeProvider = ({ children }) => {
  return <Provider theme={{ ...theme }}>{children}</Provider>
}
